import { useCallback, useEffect, useState } from 'react';

const CHAT_BOTTOM_OFFSET_VAR = '--chat-bottom-offset';

type Options = {
  shouldApplyOffset?: boolean;
  bottomMargin?: number;
};

const defaultOptions: Options = {
  shouldApplyOffset: true,
  bottomMargin: undefined,
};

export const useChatBottomOffset = <T extends HTMLElement>(
  optionsProps: Options = {}
) => {
  const options = { ...defaultOptions, ...optionsProps };
  const [element, setElement] = useState<T | null>(null);

  const ref = useCallback((node: T | null) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!options.shouldApplyOffset || !element) {
      return;
    }

    const root = document.documentElement;

    const setBottom = (height: number) => {
      root.style.setProperty(
        CHAT_BOTTOM_OFFSET_VAR,
        `calc(${options.bottomMargin ?? 24}px + ${height}px)`
      );
    };

    const observer = new ResizeObserver(() => {
      setBottom(element.offsetHeight);
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
      root.style.removeProperty(CHAT_BOTTOM_OFFSET_VAR);
    };
  }, [element, options.bottomMargin, options.shouldApplyOffset]);

  return ref;
};
